import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import ModelsView from '../views/ModelsView.vue'
import ContactUs from '../views/ContactUs.vue'
import NewsView from '../views/NewsView.vue'
import NewsList from '../views/NewsList.vue'
import CarDetails from '../views/CarDetails.vue'
import IcaurKOC from '../views/IcaurKOC.vue'



import AboutUs from '../views/AboutUs.vue'
import PaymentSuccess from '../views/PaymentSuccess.vue'
import PaymentFailure from '../views/PaymentFailure.vue'

// function getLocalePath(path, locale) {
//   return path + (locale ? '-' + locale : ''); // 根据是否提供locale来决定是否添加后缀
// }

// params: { lang: 'zh' },
const routes = [
  { path: '/', component: HomeView, meta: { title: 'iCAUR HK' } },
  { path: '/contact-us', component: ContactUs, meta: { title: '聯絡我們 | iCAUR HK' } },
  { path: '/news/details', component: NewsView, meta: { title: '最新消息 | iCAUR HK' } },
  { path: '/news', component: NewsList, meta: { title: '最新消息 | iCAUR HK' } },
  { path: '/models/:slug', component: CarDetails, meta: { title: '車型詳情 | iCAUR HK' } },
  { path: '/about', component: AboutUs, meta: { title: '關於我們 | iCAUR HK' } },
  { path: '/contact-us/succeed', component: PaymentSuccess, meta: { title: '提交成功 | iCAUR HK' } },
  { path: '/contact-us/failure', component: PaymentFailure, meta: { title: '提交失敗 | iCAUR HK' } },
  { path: '/koc_recruit', component: IcaurKOC, meta: { title: 'KOC 招募活動 | iCAUR HK' } },
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes,
  // 切换页面时滚动到顶部（浏览器前进/后退时恢复原位置）
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

// 动态设置页面标题
router.afterEach((to) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
})

export default router